import { createSvgIcon } from "@material-ui/core/utils";
import React from "react";

export const DeveloperIcon = createSvgIcon(
  <>
    <path
      d="M12.5 10.5L11 17.5"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="transparent"
    />
    <path
      d="M3 7V5C3 3.89543 3.89543 3 5 3H19C20.1046 3 21 3.89543 21 5V7M3 7V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V7M3 7H21"
      stroke="currentColor"
      strokeWidth="2"
      fill="transparent"
    />
    <path
      d="M8 12L6 14L8 16"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="transparent"
    />
    <path
      d="M16 12L18 14L16 16"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="transparent"
    />
  </>,
  "DeveloperIcon"
);
